import React, { Component } from 'react';
import './style.scss';
import { Link } from 'react-router-dom';

export default class GridItem extends Component {
    render() {
        return (
            <Link to={{ pathname: '/view-pet', state: { pet: this.props.pet } }} className='grid-item'>
                <div className='avatar' style={{ background: `url('${this.props.pet.picture}') no-repeat center`, backgroundSize: 'cover' }}></div>
                <div className="breed-name">{this.props.pet.name}</div>
                <div><strong>Age: </strong>{this.props.pet.age} yr</div>
                <div><strong>Weight: </strong>{this.props.pet.weight} lbs;</div>
                <div><strong>Gender: </strong>Female</div>
                <div><strong>Breed: </strong>{this.props.pet.breed}</div>
            </Link>
        );
    }
}
